"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _useValidation = _interopRequireDefault(require("../Form/use-validation"));
var _FormGroup = _interopRequireDefault(require("../FormGroup"));
var _CheckableGroupModule = _interopRequireDefault(require("./CheckableGroup.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const CheckableGroup = _ref => {
  let {
    className,
    testAttrRoot,
    testAttrError,
    children,
    id,
    name,
    label,
    required,
    disabled,
    helpNode,
    error,
    customValidationError,
    onChange,
    onInvalid
  } = _ref;
  const [selectedItems, setSelectedItems] = (0, _react.useState)(() => {
    const items = [];
    _react.Children.forEach(children, _ref2 => {
      let {
        props: {
          id: childId,
          defaultChecked
        }
      } = _ref2;
      if (defaultChecked) {
        items.push(childId);
      }
    });
    return items;
  });
  const {
    errorId,
    isValid,
    errorElement,
    showInvalid,
    setValidationState
  } = (0, _useValidation.default)({
    id,
    error,
    customValidationError,
    onInvalid
  });
  const onChangeCallback = evt => {
    const {
      target: {
        id: targetId,
        checked
      }
    } = evt;
    setValidationState(null);
    setSelectedItems(prevState => checked ? [...prevState, targetId] : prevState.filter(selectedItem => selectedItem !== targetId));
    if (onChange) {
      onChange(evt);
    }
  };
  const onInvalidCallback = state => {
    setValidationState(state);
    if (onInvalid) {
      onInvalid(state);
    }
  };
  const describedBy = [];
  if (helpNode) {
    describedBy.push("".concat(id, "-help"));
  }
  if (showInvalid) {
    describedBy.push(errorId);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormGroup.default, _objectSpread(_objectSpread(_objectSpread({
    className: (0, _cnbuilder.cnb)(_CheckableGroupModule.default.root, {
      [_CheckableGroupModule.default.withHelpNode]: Boolean(helpNode)
    }, {
      [_CheckableGroupModule.default.containsError]: !isValid
    }, {
      [_CheckableGroupModule.default.disabled]: disabled
    }, className)
  }, !isValid && {
    'data-invalid-field': true
  }), {}, {
    testAttrRoot: testAttrRoot,
    legend: /*#__PURE__*/(0, _react.cloneElement)(label, {
      className: (0, _cnbuilder.cnb)(_CheckableGroupModule.default.label, label.props.className),
      useLabelElement: false,
      required
    })
  }, showInvalid && {
    error: /*#__PURE__*/(0, _react.cloneElement)(errorElement, {
      id: errorId,
      testAttr: testAttrError
    })
  }), {}, {
    children: [helpNode && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _CheckableGroupModule.default.helpNode,
      id: "".concat(id, "-help"),
      children: helpNode
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _CheckableGroupModule.default.items,
      children: _react.Children.map(children, child => {
        const {
          id: childId,
          disabled: childDisabled
        } = child.props;
        const selectedItemIndex = selectedItems.findIndex(selectedItem => selectedItem === childId);
        return /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread(_objectSpread({
          name,
          classNameRoot: _CheckableGroupModule.default.item,
          // eslint-disable-next-line no-undefined
          defaultChecked: undefined,
          checked: selectedItems[selectedItemIndex] === childId,
          disabled: disabled || childDisabled,
          required: required && !selectedItems.length
        }, describedBy.length && {
          'aria-describedby': describedBy.join(' ')
        }), {}, {
          'aria-invalid': !isValid,
          onInvalid: onInvalidCallback,
          onChange: onChangeCallback
        }));
      })
    })]
  }));
};
CheckableGroup.defaultProps = {
  testAttrRoot: 'checkable-group-root',
  testAttrError: 'checkable-group-error'
};
var _default = exports.default = CheckableGroup;